import React, { useEffect, useRef, useState } from "react";
import Button from "../../../components/common/ui/Button";
import {
  CheckBoxInput,
  FileInput,
  RadioInput,
  TextAreaInput,
} from "../../../components/common/ui/Inputs";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../components/common/table/Table";
import { history } from "../../../_helpers";
import { Link, useLocation } from "react-router-dom";
import {
  masterActions,
  staffRequestAction,
  authActions,
  facilityAction,
} from "../../../_store";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../../components/common/ui/Loader";
import { messageToInmateRequestFormSchema } from "../../../validation/staffRequestSchema";
import { StoredProcedures } from "../../../_helpers/enumerator";
import ExcelExport from "../../../components/common/ui/Export/ExcelExport";
import generateXlsx from "../../../components/common/export/generateXlsx";
import {
  exportDate,
  formatDateTimeAMPM,
  getCurrentDate,
  getCurrentTime,
} from "../../../utils/formatTime";
import PdfViewer from "../../../components/common/PdfViewer/PdfViewer";
import MessageToInmateFormHeader from "./MessageToInmateFormHeader";
//import useTranslate from "../../../utils/useTranslation";
import translateText from "../../../_helpers/GoogleTranslator";
import { getStoredValue } from "../../../_helpers/storagehelper";
function MessageToInmateRequestForm() {
  const componentRef = useRef();
  const componentRef1 = useRef();
  const componentRef2 = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  const formID = location?.state ? location?.state?.formID : 0;
  const formDetails = location?.state ? location?.state?.formDetails : {};
  const RequestFormType = location?.state
    ? location?.state?.RequestFormType
    : 0;
  const RequestForumMGUserThreadID = location?.state
    ? location?.state?.RequestForumMGUserThreadID
    : 0;
  const RequestFormTypeID = location?.state
    ? location?.state?.RequestFormTypeID
    : 0;

  const [requestFormSubmitted, setRequestFormSubmitted] = useState(false);

  // const InmateID = location?.state ? location?.state?.InmateID : 0;

  const InmateResidentId = location?.state
    ? location?.state?.InmateResidentId
    : 0;

  const oldRequestFormTitle = location?.state
    ? location?.state?.oldRequestFormTitle
    : 0;

  const sourceFrom = location?.state ? location?.state?.sourceFrom : "";

  const loggedUser = getStoredValue("user")?.ManagementUserID;

  const {
    updateRequestFormTypePopupdata,
    updateChangeRequestFormTypeData,
    requestReview,
    LoadInmateMGUserRequestForumPostResonse,
    LoadInmateMGUserRequestForumResponse,
    submitMessageToInmateRequestFormInfoResponse,
    UpdateMURequestReadResponse,
    messageToInmateRequestFormPayloadData, //form data
    indexValue,
    loading,
  } = useSelector((x) => x?.staffRequest);

  // const { facilityDetails } = useSelector((x) => x?.facility);
  const { GetFacilityStaffReqInfoResponse, loading: facilityLoader } =
    useSelector((x) => x?.facility);
  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const { ReplyMode } = useSelector((x) => x.dropdownOptions);
  const { user, commonFacilityCode } = useSelector((x) => x.auth);

  // const { translatedMessages, translateMessages } = useTranslate();

  const [facilityName, setFacilityName] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [requestFormTypePopup, setRequestFormTypePopUp] = useState({
    requestFormTypeID: RequestFormType,
    newRequestFormTypeId: 0,
    inmateResidentId: InmateResidentId,
    facilityCode: facilityCode,
  });

  const [transLoader, setTransLoader] = useState(false);
  const MAX_FILE_SIZE = parseInt(process.env.REACT_APP_MAX_FILESIZE, 10);
  const [updateRequestFormType, setUpdateRequestFormType] = useState({
    facilityID: facilityCode,
    oldRequestFormTypeID: RequestFormType,
    newRequestFormTypeID: requestFormTypePopup?.newRequestFormTypeId,
    requestForumThreadID: formID,
    managementUserID: loggedUser,
    oldRequestFormTitle: oldRequestFormTitle,
    newRequestFormTitle: "",
  });

  const [requestFormTable, setRequestFormTable] = useState({
    formID: formID,
    pageNo: 1,
    rowCountPerPage: 10,
  });
  const [pdfdata, setpdfdata] = useState(null);
  const [selectLang, setselectLang] = useState("");
  const [updateRequestColumn, setUpdateRequestColumn] = useState([]);
  const [updatePostByColumn, setUpdatePostByColumn] = useState([]);
  const prevFacilityCodeRef = useRef(facilityCode);


  const [showReplyModal, setShowReplyModal] = useState(false);

  useEffect(() => {
    if (formID == 0) {
      history?.navigate("/Admin/StaffRequestList/MessageToInmate");
    }
  }, [formID]);

  //load facility drop down
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    )
      .then((data) => {
        const facilityList = data?.payload;
        const facilityName = facilityList?.find(
          (x) => x?.value === facilityCode
        )?.label;
        setFacilityName(facilityName);
      })
      .catch(() => {
        setFacilityName("");
      });
  }, []);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== facilityCode) {
      history.navigate("/Admin/StaffRequestList/MessageToInmate");
    }

    if (prevFacilityCodeRef.current !== facilityCode && facilityCode === 0) {
      history.navigate("StaffRequestList");
    }
  }, [facilityCode]);

  useEffect(() => {
    dispatch(
      facilityAction?.GetFacilityStaffReqInfo({
        facilityID: facilityCode,
      })
    );
  }, []);

  useEffect(() => {
    switch (updateRequestFormTypePopupdata?.IsSucceed) {
      case 1:
        Popup({
          title: "Message",
          text: `Your chosen form is not allow to create the new request by 
          Inmates but your selected form is allow to create the New request 
          by Inmates. If you want to proceed, Admin  is not allow to create 
          the New request. Are you sure, you want to reassign the selected 
          form to chosen form?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        break;
      case 2:
        Popup({
          title: "Message",
          text: `Your chosen form limit is Zero. 
          If you want to proceed, Inmates not allow to create this request form. 
          Admin only allow to create the new request.
          Are you sure, you want to reassign the selected form to chosen form ?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        break;
      case 0:
        Popup({
          title: "Message",
          text: `Are you sure you want to Re-assign this Forum to another Forum type?`,
          icon: "info",
          confirmButtonText: "YES",
          cancelButtonText: "NO",
          onConfirm: () =>
            dispatch(
              staffRequestAction.updateChangeRequestFormType(
                updateRequestFormType
              )
            ),
        });
        break;

      default:
        break;
    }
  }, [updateRequestFormTypePopupdata]);

  useEffect(() => {
    if (RequestFormTypeID > 0) {
      getFormDetails();
      getTableData();
    }
  }, [indexValue, RequestFormTypeID, requestFormTable?.pageNo, requestFormTable?.rowCountPerPage]);

  const getFormDetails = () => {
    dispatch(
      staffRequestAction?.LoadInmateMGUserRequestForum({
        RequestFormTypeID: RequestFormTypeID,
      })
    )
      .then((result) => {
        const data = result?.payload;
        // const searchData = { ...messageToInmateRequestFormPayloadData };
        // searchData.requestForumThreadID = data?.RequestForumMGUserThreadID;
        // searchData.inmatesId = data?.InmateID;
        // searchData.podCode = data?.PodCode;
        // searchData.managementUserID = data?.loggedUser;
        // searchData.facilityID = data?.facilityCode;
        // searchData.pdFormPostBody = "";
        // searchData.pdfAttachPath = "";
        dispatch(
          staffRequestAction?.resetMessageToInmateRequestFormPayloadData()
        );
        // setRequestFormData(searchData);
        if (
          data?.RequestCurrentStatus === "Open" &&
          data?.RequestCreateBy === loggedUser
        ) {
          setShowReplyModal(true);
        } else {
          setShowReplyModal(false);
        }
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };

  const getTableData = () => {
    dispatch(
      staffRequestAction?.LoadInmateMGUserRequestForumPost({
        RequestFormTypeID: RequestFormTypeID,
        pageNo: requestFormTable?.pageNo,
        rowCountPerPage: requestFormTable?.rowCountPerPage,
      })
    )
      .then((result) => {
        if (result?.payload) {
          handleTranslate(selectLang, result?.payload);
        }
      })
      .catch((err) => {
        showToastNotification("Failed to get grid data", "error");
      });
  };

  useEffect(() => {
    if (updateChangeRequestFormTypeData?.IsSucceed > 0) {
      // Insert Management User Activity Log
      dispatch(
        authActions?.ManagementUserActivityLog({
          ManagementUserID: user?.ManagementUserID,
          facilityID: commonFacilityCode ? commonFacilityCode : 0,
          ProcedureName: StoredProcedures?.ChangedFormType,
          UserAction: `UspMoveForumFormToNewForum ( RequestForumThreadID - ${formID} )`,
        })
      );
      showToastNotification("Form Reassigned Successfully.", "success");
      history?.navigate("/Admin/StaffRequestList");
      dispatch(staffRequestAction?.resetForm());
    }
    if (updateChangeRequestFormTypeData?.IsSucceed === -1) {
      showToastNotification("'Forum thread not found.", "success");
      history?.navigate("/Admin/StaffRequestList");
      dispatch(staffRequestAction?.resetForm());
    }
  }, [updateChangeRequestFormTypeData]);

  useEffect(() => {
    dispatch(
      masterActions.GetPublicDefenderNotificationAlert({
        ManagementUserID: loggedUser,
        FacilityID: facilityCode,
      })
    ).then((response) => {
      const updatedMenuList = getStoredValue("menu_list") || response?.payload;

      if (updatedMenuList) {
        dispatch(authActions.updateMenuList(updatedMenuList));
      }
    });

    dispatch(
      staffRequestAction?.getInmateMessageCount({
        FacilityCode: facilityCode,
        ManagementUserID: loggedUser,
      })
    );
  }, []);

  useEffect(() => {
    switch (submitMessageToInmateRequestFormInfoResponse?.IsSucceed) {
      case 1:
        const searchData = { ...messageToInmateRequestFormPayloadData };
        searchData.pdFormPostBody = "";
        searchData.pdfAttachPath = "";
        searchData.activeStatus = 0;
        searchData.postType = 1;

        dispatch(
          staffRequestAction?.updateMessageToInmateRequestFormPayload(
            searchData
          )
        );

        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode ? commonFacilityCode : 0,
            ProcedureName: StoredProcedures?.RequestPublicDefenderThreadRespond,
            UserAction: `MG User Responded to Inmate Request ( PRequestFormTypeID -${formID})`,
          })
        );

        dispatch(
          staffRequestAction?.UpdateMURequestRead({
            requestID: formID,
            requestFormTypeID: RequestFormType,
            facilityID: facilityCode,
            createdBy: loggedUser,
          })
        );
        dispatch(
          masterActions.GetLoadNotificationAlert({
            ManagementUserID: loggedUser,
            FacilityID: facilityCode,
          })
        );

        dispatch(
          masterActions.GetPublicDefenderNotificationAlert({
            ManagementUserID: loggedUser,
            FacilityID: facilityCode,
          })
        ).then((response) => {
          const updatedMenuList = getStoredValue("menu_list") || response?.payload;

          if (updatedMenuList) {
            dispatch(authActions.updateMenuList(updatedMenuList));
          }
        });

        dispatch(
          staffRequestAction?.getInmateMessageCount({
            FacilityCode: facilityCode,
            ManagementUserID: loggedUser,
          })
        );

        getTableData();
        getFormDetails();
        dispatch(staffRequestAction?.resetForm());
        setRequestFormSubmitted(true);
        showToastNotification("Reply Sent Successfully.", "success");
        break;
      case -2:
        showToastNotification("Not Exist This Thread.", "error");
        break;

      case -1:
        showToastNotification("Operation Failed", "error");
        break;

      case -3:
        showToastNotification(
          "Not Valid Management User to Post this Request Type",
          "error"
        );
        break;

      case -4:
        showToastNotification("Text or PDF file is empty", "error");
        break;

      default:
        break;
    }
  }, [submitMessageToInmateRequestFormInfoResponse]);

  const handlePrints = useReactToPrint({
    pageStyle: `@media print {
      @page {
       size: A4 portrait;
        margin: 2 !important;
         padding: 2 !important;
      }
      body {
        height: auto !important;
        overflow: hidden !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      * {
        
        font-size: 16px !important;
      }

      table, th, td {
        border: 2px solid black !important;
      }

      .print-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        break-inside: avoid;
        page-break-inside: avoid;
      }

      .print-date {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 14px;
        font-weight: bold;
      }

      .rdt_Pagination,
      .sc-diYFot jfOLQZ rdt_Pagination,
      .pagination-postion,
       .sc-diYFot,
       .jfOLQZ
        {
         display: none !important;
       }
    }
  `,
    content: () => {
      const combinedContent = document.createElement("div");
      if (componentRef2.current) {
        combinedContent.appendChild(componentRef2.current.cloneNode(true));
      }
      if (componentRef1.current) {
        combinedContent.appendChild(componentRef1.current.cloneNode(true));
      }
      return combinedContent;
    },
    onBeforeGetContent: () => { },
  });

  const handleDownloadPDF = (e, row) => {
    e?.preventDefault();

    const splitFolderPath = row?.PdfDocAttachPath?.split("/");
    const folderPath =
      splitFolderPath[1] + "/" + splitFolderPath[2] + "/" + splitFolderPath[3];
    const fileName = splitFolderPath[4];
    dispatch(
      staffRequestAction?.DownLoadFile({
        folderPath: folderPath,
        filename: fileName,
      })
    )
      .then((result) => {
        setpdfdata(result?.payload);
      })
      .catch((err) => {
        showToastNotification("Failed to view PDF", "error");
      });
  };

  const exportRequestForm = async () => {
    let generateExcelColumns = ["Request", "Posted By", "Sent Date time"];
    try {
      const result = await dispatch(
        staffRequestAction?.LoadInmateMGUserRequestForumPost({
          RequestFormTypeID: RequestFormTypeID,
          pageNo: 1,
          rowCountPerPage: LoadInmateMGUserRequestForumPostResonse?.TotalRecordCount,
          isExcelExport: true
        })
      );
      const dataList = result?.payload?.DataList;

      // Use async map with Promise.all
      const exportData = await Promise.all(
        dataList?.map(async (obj) => {
          const translatedRequest =
            obj?.IsAttachDocPDF === 1 && obj?.IsPostText === 1
              ? (selectLang == "en" || selectLang == "es" ? (await translateText(obj.ForumPostBody, selectLang)) : obj.ForumPostBody) +
              " (Replied as PDF)"
              : obj?.IsAttachDocPDF === 1
                ? "(Replied as PDF)"
                : (selectLang == "en" || selectLang == "es" ? await translateText(obj.ForumPostBody, selectLang) : obj.ForumPostBody);

          const translatedBy = (selectLang == "en" || selectLang == "es" ? await translateText(
            obj.ForumThreadPostBy,
            selectLang
          ) : obj.ForumThreadPostBy);

          return {
            Request: translatedRequest,
            "Posted By": translatedBy,
            "Send Date time": formatDateTimeAMPM(obj.ReqPostSendDate),
          };
        })
      );

      const currentTime = exportDate(new Date());
      generateXlsx(
        exportData,
        generateExcelColumns,
        `Form Info_${currentTime}`
      );
    } catch (err) {
      showToastNotification("Error in Export Data", "error");
    }
  };

  const column = [
    {
      name: "Request",
      // width: "350px",
      selector: (row) => row.request,
      cell: (row, i) =>
        row.PostByInmate === 1 ? (
          <div div className="d-flex flex-column gap-2 align-items-start">
            <div className="d-flex gap-2">
              <i
                className="fa-solid fa-reply inmate-replied fs-3"
                aria-hidden="true"
                title="Inmate Replied"
              ></i>
              <div
                className="pre-wrap-text"
                dangerouslySetInnerHTML={{
                  __html:
                    updateRequestColumn?.length > 0
                      ? updateRequestColumn[i]
                      : showmessagecontent(row?.ForumPostBody),
                }}
              ></div>
            </div>
            {row?.PdfDocAttachPath && row?.IsPostText && (
              <div className="d-flex align-items-center gap-2">
                <Link
                  className="btn button-success btn-lg w-inherit cursor-pointer"
                  onClick={(e) => handleDownloadPDF(e, row)}
                >
                  <i class="fa-solid fa-file-pdf me-2"></i> View PDF
                </Link>
              </div>
            )}
          </div>
        ) : (
          // Example "else if" condition
          <div div className="d-flex flex-wrap  gap-2 align-items-start">
            <div className="d-flex gap-2">
              <i
                className="fa-solid fa-user-shield admin-replied fs-3"
                aria-hidden="true"
                title="Admin Replied"
              />
              <div
                className="pre-wrap-text"
                dangerouslySetInnerHTML={{
                  __html:
                    updateRequestColumn?.length > 0
                      ? updateRequestColumn[i]
                      : showmessagecontent(row?.ForumPostBody),
                }}
              ></div>
            </div>
            {row?.PdfDocAttachPath && (
              <Link
                className="btn button-success btn-lg w-inherit cursor-pointer"
                onClick={(e) => handleDownloadPDF(e, row)}
              >
                <i class="fa-solid fa-file-pdf me-2"></i> View PDF
              </Link>
            )}
          </div>
        ),
      sortable: false,
    },

    {
      name: "Posted By",
      selector: (row) => row.ForumThreadPostBy,
      cell: (row, i) => (
        <div
          className="d-flex flex-wrap gap-2"
          dangerouslySetInnerHTML={{
            __html:
              updatePostByColumn?.length > 0
                ? updatePostByColumn[i]
                : showmessagecontent(row?.ForumThreadPostBy),
          }}
        ></div>
      ),
      sortable: false,
    },
    {
      name: "Sent Date Time",
      selector: (row) => formatDateTimeAMPM(row.ReqPostSendDate),
      sortable: false,
    },
  ];

  const handleRowPerPage = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      rowCountPerPage: page,
      pageNo: 1,
    }));
  };

  const handlePageChange = (page) => {
    setRequestFormTable((prevState) => ({
      ...prevState,
      pageNo: page,
    }));
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e?.target;
    const errorList = { ...errorMessage };
    delete errorList[name];
    setErrorMessage(errorList);
    if (type === "file" && files?.length === 0) {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "Please upload PDF Document.",
      }));
      const data = { ...messageToInmateRequestFormPayloadData };
      data["file"] = "";
      data["fileType"] = "";
      data["fileSize"] = 0;
      // data["fileType"] = "";
      // data["fileSize"] = "";
      dispatch(
        staffRequestAction?.updateMessageToInmateRequestFormPayload(data)
      );
      // setRequestFormData(data);
      return;
    }

    if (type === "file" && files?.length > 0) {
      const fileType = files?.[0]?.type;
      const fileSize = files?.[0]?.size;
      if (fileSize > MAX_FILE_SIZE) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "File size should not exceed 20MB.",
        }));
      }
      if (fileType !== "application/pdf") {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "Please select PDF Document.",
        }));
        const data = { ...messageToInmateRequestFormPayloadData };
        data["file"] = { type: fileType, size: 0 };
        data["fileType"] = fileType;
        data["fileSize"] = 0;
        dispatch(
          staffRequestAction?.updateMessageToInmateRequestFormPayload(data)
        );
        // setRequestFormData(data);
        return;
      }
      // setErrorMessage({});
      const reader = new FileReader();
      reader.onloadend = () => {
        let formData = { ...messageToInmateRequestFormPayloadData };
        const fileName = files[0]?.name;
        const lastIndex = fileName?.lastIndexOf(".");
        const removedExtensionTxt = [...fileName]
          .splice(0, lastIndex)
          .toString();
        const removeWhitSpace = removedExtensionTxt.replace(
          /[+\-\/,?*:;<>@#$%^&!~\s]/g,
          ""
        );
        const removedExtraTxt = [...removeWhitSpace].splice(0, 100).join(""); //retutn only 100 characters
        const currentDate = getCurrentDate()?.split("/").join("");
        const currentTime = getCurrentTime().split(":").join("");
        const now = new Date();
        // const timestamp = now.getFullYear().toString() +
        //   String(now.getMonth() + 1).padStart(2, "0") +
        //   String(now.getDate()).padStart(2, "0") +
        //   String(now.getHours()).padStart(2, "0") +
        //   String(now.getMinutes()).padStart(2, "0") +
        //   String(now.getSeconds()).padStart(2, "0");
        formData["file"] = reader.result.split(",")[1];
        formData["filename"] = removedExtraTxt;
        // formData["facilityCode"] = facilityName;
        formData["fileType"] = files?.[0]?.type;
        formData["fileSize"] = files?.[0]?.size;
        formData["facilityCode"] =
          GetFacilityStaffReqInfoResponse?.FacilityName;
        dispatch(
          staffRequestAction?.updateMessageToInmateRequestFormPayload(formData)
        );
        // setRequestFormData(formData);
      };
      reader.readAsDataURL(files[0]);
    }
    const formData = { ...messageToInmateRequestFormPayloadData };
    if (type === "radio") {
      setErrorMessage({});
      formData[name] = parseInt(value);
      formData["pdFormPostBody"] = "";
      formData["file"] = "";
      formData["filename"] = "";
      formData["fileType"] = "";
      formData["fileSize"] = 0;
      const fileInput = document.getElementById("fileInput");
      if (fileInput) {
        fileInput.value = "";
      }
    }

    if (type === "checkbox") {
      formData[name] = checked ? 1 : 0;
    }

    if (type === "textarea") {
      if (/^\s/.test(value)) return;
      formData[name] = value;
    }
    dispatch(
      staffRequestAction?.updateMessageToInmateRequestFormPayload(formData)
    );
    // setRequestFormData(formData);
  };

  const showmessagecontent = (Value) => {
    const highlightedMessageContent = `<span >${Value}</span>`;
    return highlightedMessageContent;
  };

  const handleTranslate = async (
    language,
    data = LoadInmateMGUserRequestForumPostResonse
  ) => {
    setTransLoader(true);
    setselectLang(language);
    const request = data?.DataList.map((msg) => msg.ForumPostBody);
    const postBy = data?.DataList.map((msg) => msg.ForumThreadPostBy);
    const translatedRequest =
      language === "es" || language === "en" ? await translateText(request, language) : request;
    const translatedPostBy =
      language === "es" || language === "en" ? await translateText(postBy, language) : postBy;
    const requestColumn = translatedRequest?.map((text) => {
      return `<span>${text}</span>`;
    });
    const posyByColumn = translatedPostBy?.map((text) => {
      return `<span>${text}</span>`;
    });
    setUpdateRequestColumn(requestColumn);
    setUpdatePostByColumn(posyByColumn);
    setTransLoader(false);
  };

  useEffect(() => {
    handleTranslate(selectLang)
  }, [selectLang])

  // const handleValidation = (e, name) => {
  //   const { error } = messageToInmateRequestFormSchema(
  //     messageToInmateRequestFormPayloadData
  //   );
  //   const errorList = { ...errorMessage };
  //   if (error?.details) {
  //     const fieldError = error.details.find((e) => e.path.toString() === name);
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       [name]: fieldError ? fieldError.message : "", // Set the error message if exists, else clear it
  //     }));
  //     const element = document.querySelector(`[name="${name}"]`);
  //     if (element) {
  //       if (fieldError) {
  //         element.classList.add("input-error");
  //       } else {
  //         element.classList.remove("input-error");
  //       }
  //     }
  //   } else {
  //     delete errorList[name];
  //     setErrorMessage(errorList);
  //     const element = document.querySelector(`[name="${name}"]`);
  //     if (element) {
  //       element.classList.remove("input-error");
  //     }
  //     // submitRequestFormInfo();
  //   }
  // };

  // const handleValidation = (e, name) => {
  //   const requestData = { ...messageToInmateRequestFormPayloadData };
  //   const file = { type: requestData?.fileType, size: requestData?.fileSize };
  //   requestData.file = file;
  //   const { error } = messageToInmateRequestFormSchema(requestData);
  //   if (error?.details) {
  //     // error?.details?.map((e) => {
  //     //   const { path } = e;
  //     //   setErrorMessage((prev) => ({
  //     //     ...prev,
  //     //     [path[0]]: e?.message,
  //     //   }));
  //     // });
  //     const fieldError = error.details.find((e) => e.path.toString() === name);
  //     setErrorMessage((prev) => ({
  //       ...prev,
  //       [name]: fieldError ? fieldError.message : "",
  //     }));
  //     return;
  //   }
  //   const fieldError = error?.details?.find(
  //     (e) => e?.path?.toString() === name
  //   );
  //   const element = document.querySelector(`[name="${name}"]`);
  //   if (element) {
  //     if (fieldError) {
  //       element.classList.add("input-error");
  //     } else {
  //       element.classList.remove("input-error");
  //     }
  //   }
  // };

  const handleValidation = (e, name) => {
    const requestData = { ...messageToInmateRequestFormPayloadData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    const { error } = messageToInmateRequestFormSchema(requestData);
    if (error?.details) {
      const fieldError = error.details.find((e) => e.path.toString() === name);
      if (fieldError && Object?.keys(fieldError)?.length > 0) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError ? fieldError.message : "",
        }));
      }
      return;
    }
    const fieldError = error?.details?.find(
      (e) => e?.path?.toString() === name
    );
    const element = document.querySelector(`[name="${name}"]`);
    if (element) {
      if (fieldError) {
        element.classList.add("input-error");
      } else {
        element.classList.remove("input-error");
      }
    }
  };

  const submitRequestFormInfo = () => {
    const requestData = { ...messageToInmateRequestFormPayloadData };
    const file = { type: requestData?.fileType, size: requestData?.fileSize };
    requestData.file = file;
    if (requestData?.activeStatus != 1) {
      const { error } = messageToInmateRequestFormSchema(requestData);
      setErrorMessage({});
      if (error?.details) {
        error?.details?.map((e) => {
          const { path } = e;
          setErrorMessage((prev) => ({
            ...prev,
            [path[0]]: e?.message,
          }));
        });
        return;
      }
      if (Object?.keys(errorMessage)?.length > 0) return;
    }
    const data = { ...messageToInmateRequestFormPayloadData };
    data.inmatesId = InmateResidentId;
    data.InmateID = LoadInmateMGUserRequestForumResponse?.InmateID;
    data.managementUserID = loggedUser;
    data.facilityID = facilityCode;
    data.requestForumThreadID = RequestFormTypeID;
    dispatch(staffRequestAction?.updateMessageToInmateRequestFormPayload(data));
    dispatch(staffRequestAction?.submitMessageToInmateRequestFormInfo(data));
  };

  const handleFormReset = () => {
    const mtmSearch = { ...messageToInmateRequestFormPayloadData };
    mtmSearch.pdFormPostBody = "";
    mtmSearch.postType = 1;
    mtmSearch.activeStatus = 0;
    mtmSearch.inmatesId = InmateResidentId;
    mtmSearch.InmateID = LoadInmateMGUserRequestForumResponse?.InmateID;
    mtmSearch.managementUserID = loggedUser;
    mtmSearch.facilityID = facilityCode;
    dispatch(staffRequestAction?.resetMessageToInmateRequestFormPayloadData());
    setErrorMessage({});
    // setRequestFormData({
    //   ...messageToInmateRequestFormPayloadData,
    //   pdFormPostBody: "",
    //   postType: 1,
    //   activeStatus: 0,
    // });
  };

  if (loading || facilityLoader || transLoader) return <CustomLoader />;

  return (
    <>
      <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
        {pdfdata && (
          <div className="d-flex flex-wrap justify-content-end gap-3">
            {/* <PrintExport
          handlePrintShow={() => {
            handlePrints();
          }}
        /> */}
            <Button
              label="Back"
              type="button"
              icon={"fa-solid fa-angle-left"}
              status="primary"
              onClick={() => {
                setpdfdata(null);
              }}
            />
          </div>
        )}
        {pdfdata ? (
          <PdfViewer data={`data:application/pdf;base64,${pdfdata}`} />
        ) : (
          <div>
            <MessageToInmateFormHeader
              source={sourceFrom}
              requestReview={requestReview}
              list={formDetails}
              handlePrints={handlePrints}
              navigateBack={"/Admin/StaffRequestList/MessageToInmate"}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              requestFormSubmitted={requestFormSubmitted}
              setRequestFormSubmitted={setRequestFormSubmitted}
            />

            <div className="request-remedy-form">
              <div className="">
                <form>
                  <div className="">
                    <article>
                      <div ref={componentRef2}>
                        <div className="d-flex flex-wrap align-items-center profile-row mb-4">
                          <div className="d-flex req-header-img">
                            {GetFacilityStaffReqInfoResponse?.LogoFile && (
                              <img
                                src={
                                  "data:image/png;base64," +
                                  GetFacilityStaffReqInfoResponse?.LogoFile
                                }
                                alt="facility-logo"
                                className="req-img"
                              />
                            )}
                          </div>
                          <div className="justify-content-center align-items-center req-header-title">
                            <h3 className="text-color py-2 text-center">
                              <span className="label-red req-text">
                                {GetFacilityStaffReqInfoResponse?.FacilityName?.toUpperCase()}
                              </span>
                            </h3>
                          </div>
                        </div>

                        <h4
                          className="request-form-header text-color mt-4"
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa-solid fa-circle-info me-2"></i>{" "}
                          MESSAGE INFORMATION
                        </h4>

                        <div className="m-1 row border-bottom-1 request-form-card details-legal">
                          <h4
                            className="request-form-header mt-2"
                            style={{ cursor: "pointer" }}
                          >
                            MESSAGE INFO
                          </h4>
                          {[
                            {
                              label: "Title",
                              value:
                                LoadInmateMGUserRequestForumResponse?.ForumThreadTitle,
                            },
                            {
                              label: "Inmate Resident ID",
                              value:
                                LoadInmateMGUserRequestForumResponse?.InmateResidentId,
                            },
                            {
                              label: "Created For",
                              value:
                                LoadInmateMGUserRequestForumResponse?.InmateFullName,
                            },
                            {
                              label: "Created On",
                              value:
                                LoadInmateMGUserRequestForumResponse?.RequestCreateDate,
                            },
                            {
                              label: "POD Code",
                              value:
                                LoadInmateMGUserRequestForumResponse?.PodCode
                                  ? LoadInmateMGUserRequestForumResponse?.PodCode
                                  : "-",
                            },
                          ].map((item, index) => (
                            <div key={index} className="col-md-12 col-lg-4">
                              <div className="user-information d-flex flex-wrap align-items-center">
                                <div className="fs-5 p-2  value-info">
                                  {item.label}
                                </div>
                                <div className="p-1">:</div>
                                <div className="fs-5 p-2 text-start fw-bold value-text">
                                  {item.value || "-"}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div>
                        {showReplyModal && (
                          <>
                            <div className="mt-4 mb-4 d-flex flex-wrap  border-0">
                              <span className="mb-0 request-form-label">
                                Reply Mode
                              </span>
                              <RadioInput
                                name="postType"
                                id="postType"
                                options={ReplyMode}
                                handleChange={(e) => handleChange(e)}
                                selectedValue={
                                  messageToInmateRequestFormPayloadData?.postType
                                }
                              />
                            </div>
                            <div className="mt-4 mb-4">
                              {(messageToInmateRequestFormPayloadData?.postType ===
                                1 ||
                                messageToInmateRequestFormPayloadData?.postType ===
                                3) && (
                                  <TextAreaInput
                                    placeholder="Enter Your Description"
                                    name="pdFormPostBody"
                                    handleChange={(e) => handleChange(e)}
                                    value={
                                      messageToInmateRequestFormPayloadData?.pdFormPostBody
                                    }
                                    errorMessage={errorMessage}
                                    handleBlur={(e) => {
                                      handleValidation(e, "pdFormPostBody");
                                    }}
                                    maxLength={2000}
                                  />
                                )}
                              {(messageToInmateRequestFormPayloadData?.postType ===
                                2 ||
                                messageToInmateRequestFormPayloadData?.postType ===
                                3) && (
                                  <FileInput
                                    acceptFormat=".pdf"
                                    name="file"
                                    id="fileInput"
                                    handleFileChange={(e) => handleChange(e)}
                                    errorMessage={errorMessage}
                                  />
                                )}
                            </div>
                            <div className="mt-4 mb-4 border-0">
                              <CheckBoxInput
                                name="activeStatus"
                                id="activeStatus"
                                label="Close"
                                handleClick={(e) => handleChange(e)}
                                checked={
                                  messageToInmateRequestFormPayloadData?.activeStatus
                                }
                              />
                            </div>
                            <div className="pb-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                              <Button
                                label="Submit"
                                status="success"
                                icon={"fa-solid fa-floppy-disk"}
                                type="button"
                                onClick={() => submitRequestFormInfo()}
                                title={"Submit"}
                              />
                              <Button
                                label="Reset"
                                title="Reset"
                                icon={"fa-solid fa-rotate-right"}
                                status="secondary"
                                type="button"
                                onClick={() => handleFormReset()}
                              />
                            </div>
                          </>
                        )}

                        <div className="mb-3 mt-3 d-flex flex-wrap mobile-left align-items-center gap-3">
                          <Button
                            label="Traducir al español"
                            title="Traducir al español"
                            status="btn-label"
                            type="button"
                            className={"w-max"}
                            icon={"language"}
                            onClick={() => setselectLang("es")}
                          />

                          <Button
                            label="Translate to English"
                            title="Translate to English"
                            status="btn-label"
                            type="button"
                            className={"w-max"}
                            icon={"globe"}
                            onClick={() => setselectLang("en")}
                          />
                          <Button
                            label="Reset"
                            title="Reset"
                            icon={"fa-solid fa-rotate-right"}
                            status="btn-label"
                            type="button"
                            onClick={() => setselectLang("")}
                          />
                          <ExcelExport
                            variant="soft-gray"
                            handleExcelExport={exportRequestForm}
                          />
                        </div>
                        <div ref={componentRef1}>
                          <Table
                            columns={column}
                            data={
                              LoadInmateMGUserRequestForumPostResonse?.DataList
                            }
                            onChangeRowsPerPage={handleRowPerPage}
                            pagination
                            onChangePage={handlePageChange}
                            totalRowCount={
                              LoadInmateMGUserRequestForumPostResonse?.TotalRecordCount
                            }
                            currentPage={requestFormTable?.pageNo}
                            paginationPerPage={requestFormTable.rowCountPerPage}
                          />
                        </div>
                      </div>
                      {/* {formType === 1 ? (
                      
                    ) : (
                      <div className="details-legal">
                        <SelectInput
                          cName={"w-50"}
                          options={formTypeListDropDown}
                          handleChange={(e) => handleFormTypeChange(e)}
                          label="Change To Form Type"
                        />
                        <div className="pt-3 gap-3 d-flex flex-wrap justify-content-start align-items-center">
                          <Button
                            label="Update"
                            title="Update"
                            status="success"
                            icon={"fa-solid fa-pen-to-square"}
                            type="button"
                            onClick={() => handleUpdateFormTypePopup()}
                          />
                          <Button
                            label="Cancel"
                            title="Cancel"
                            status="secondary"
                            type="button"
                            onClick={() => setFormType(1)}
                          />
                        </div>
                      </div>
                    )} */}
                    </article>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default React.memo(MessageToInmateRequestForm);
